import * as React from 'react';

import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Text, { Props as TextProps } from 'ha/ui/next/Text';
import units from 'ha/theme/units';
import { CopyText } from '../types';

interface Props {
  text: CopyText;
}

export const styles = createStyles({
  header: {
    marginTop: units.rem(2),
  },
});

const mapTypeToVariant: { [type: string]: TextProps['variant'] } = {
  h2: 'title',
  h3: 'subheading',
  p: 'body2',
  subtitle: 'body2',
};

export const CityInfo: React.SFC<Props & WithStyles<typeof styles>> = ({
  text,
  classes,
}) => (
  <div>
    {text.map((part, index) => {
      if (part.type === 'h2' || part.type === 'h3') {
        return (
          <Text
            key={index}
            className={classes.header}
            variant={mapTypeToVariant[part.type]}
            // for seo purposes
            component={part.type === 'h3' ? 'h2' : undefined}
            gutterBottom
            fw="bold"
          >
            {part.text}
          </Text>
        );
      }

      return (
        <Text
          key={index}
          variant={mapTypeToVariant[part.type]}
          paragraph
          italic={part.type === 'p' && part.style === 'italic'}
          kind={part.type === 'subtitle' ? 'price' : undefined}
        >
          {part.text}
        </Text>
      );
    })}
  </div>
);

export default withStyles(styles)(CityInfo);
